import SwCacheService from 'app/services/swCache.service';
import AdminService from 'external-services/diary-admin-service/admin.service';
import {appValues} from "appRoot/app.constants";

const NS = 'AppUpdateDialogCtrl';

export default function AppUpdateDialogCtrl(
  $scope, $mdDialog, dismissCount, appConstants, $state
) {
  "ngInject";

  const vm = this;

  const LOAD_STATUS_TYPES = {
    IDLE: 1,
    CLEARING_CACHES: 2,
    READY_TO_RELOAD: 3
  };

  vm.LOAD_STATUS_TYPES = LOAD_STATUS_TYPES;

  vm.loadStatus = LOAD_STATUS_TYPES.IDLE;
  vm.oldVersion = appValues.VERSION_SHORT;
  vm.availableVersion = SwCacheService.getAvailableVersion();

  $scope.canDismiss = true;
  if (appConstants.AppCache.ReloadDialogDismissLimit > 0 && dismissCount >= appConstants.AppCache.ReloadDialogDismissLimit) {
    $scope.canDismiss = false;
  }
  $scope.cancel = function () {
    $mdDialog.hide();
  };
  $scope.ok = function () {
    vm.loadStatus = LOAD_STATUS_TYPES.CLEARING_CACHES;

    /**
     * account and venue can get cleared from local storage unintentionally, but is needed for successful reload after
     * new version updated
     */
    AdminService.setAccountLocalStorageFromMemory();
    AdminService.setVenueLocalStorageFromMemory();

    SwCacheService.deleteCache(error1 => {
      SwCacheService.cacheUnregister(error2 => {
        /**
         * If the cache doesn't exist or fails, still do the reload.
         */
        // vm.loadStatus = LOAD_STATUS_TYPES.READY_TO_RELOAD;
        window.location.reload();
      });
    });
  };
}
